"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EssClientLogger = void 0;
var ClientMetricsLogger_1 = require("./ClientMetricsLogger");
var Experiments_1 = require("./Experiments");
var TypeaheadEventLogger_1 = require("./TypeaheadEventLogger");
var Utils_1 = require("./utils/Utils");
var EssClientLogger = /** @class */ (function () {
    function EssClientLogger(analytics, clientLogger, prefill, experiments) {
        try {
            Experiments_1.Experiments.init(experiments);
            Utils_1.Utils.init(clientLogger);
            this.tel = new TypeaheadEventLogger_1.TypeaheadEventLogger(analytics, prefill);
            this.cml = new ClientMetricsLogger_1.ClientMetricsLogger(clientLogger);
        }
        catch (e) {
            Utils_1.Utils.logError(e);
        }
    }
    EssClientLogger.prototype.initLogger = function (metadata) {
        this.metadata = metadata;
    };
    EssClientLogger.prototype.logTypeaheadOpen = function (prefill) {
        var _a, _b, _c, _d;
        try {
            (_a = this.tel) === null || _a === void 0 ? void 0 : _a.initLogger(this.metadata);
            (_b = this.cml) === null || _b === void 0 ? void 0 : _b.initLogger(this.metadata);
            (_c = this.tel) === null || _c === void 0 ? void 0 : _c.logTypeaheadOpen(prefill);
            (_d = this.cml) === null || _d === void 0 ? void 0 : _d.logTypeaheadOpen(prefill);
        }
        catch (e) {
            Utils_1.Utils.logError(e);
        }
    };
    EssClientLogger.prototype.logTypeaheadRequest = function (query) {
        var _a, _b;
        try {
            (_a = this.tel) === null || _a === void 0 ? void 0 : _a.logTypeaheadRequest(query);
            (_b = this.cml) === null || _b === void 0 ? void 0 : _b.logTypeaheadRequest(query);
        }
        catch (e) {
            Utils_1.Utils.logError(e);
        }
    };
    EssClientLogger.prototype.logTypeaheadResponse = function (response) {
        var _a;
        try {
            this.prevResponse = this.response;
            this.response = response;
            (_a = this.cml) === null || _a === void 0 ? void 0 : _a.logTypeaheadResponse(response);
        }
        catch (e) {
            Utils_1.Utils.logError(e);
        }
    };
    EssClientLogger.prototype.logSuggestionShown = function (query) {
        var _a, _b, _c, _d;
        try {
            this.shownResponse = query === ((_a = this.response) === null || _a === void 0 ? void 0 : _a.q) ? this.response :
                (query === ((_b = this.prevResponse) === null || _b === void 0 ? void 0 : _b.q) ? this.prevResponse : undefined);
            if (this.shownResponse) {
                (_c = this.tel) === null || _c === void 0 ? void 0 : _c.logTypeaheadResponse(this.shownResponse);
                (_d = this.cml) === null || _d === void 0 ? void 0 : _d.logSuggestionShown(this.shownResponse);
            }
        }
        catch (e) {
            Utils_1.Utils.logError(e);
        }
    };
    EssClientLogger.prototype.logSuggestionSelected = function (selected) {
        var _a, _b, _c;
        try {
            if (this.shownResponse && selected) {
                if (selected.displayType === "CATEGORIZED")
                    selected.index += 1;
                var m = (_a = this.tel) === null || _a === void 0 ? void 0 : _a.logSuggestionSelected(selected);
                (_b = this.cml) === null || _b === void 0 ? void 0 : _b.logSuggestionSelected(selected, m);
                this.resetResponse();
            }
            if (!selected) {
                // then user selects resolve path
                (_c = this.tel) === null || _c === void 0 ? void 0 : _c.isResolveNoSuggestionSelected(true);
            }
        }
        catch (e) {
            Utils_1.Utils.logError(e);
        }
    };
    EssClientLogger.prototype.logResponse = function (response) {
        var _a, _b;
        try {
            if (!response.ok) {
                (_a = this.cml) === null || _a === void 0 ? void 0 : _a.logError(response.status, response.statusText);
            }
            (_b = this.cml) === null || _b === void 0 ? void 0 : _b.logResponse(response);
        }
        catch (e) {
            Utils_1.Utils.logError(e);
        }
    };
    EssClientLogger.prototype.logTypeaheadBlurEvent = function () {
        var _a, _b;
        try {
            (_a = this.tel) === null || _a === void 0 ? void 0 : _a.logTypeaheadBlurEvent();
            (_b = this.cml) === null || _b === void 0 ? void 0 : _b.logTypeaheadClientMetrics();
            this.resetResponse();
        }
        catch (e) {
            Utils_1.Utils.logError(e);
        }
    };
    EssClientLogger.prototype.logWizardSubmitEvent = function () {
        var _a;
        try {
            (_a = this.tel) === null || _a === void 0 ? void 0 : _a.logWizardSubmitEvent();
        }
        catch (e) {
            Utils_1.Utils.logError(e);
        }
    };
    EssClientLogger.prototype.resetResponse = function () {
        this.prevResponse = this.response = this.shownResponse = undefined;
    };
    return EssClientLogger;
}());
exports.EssClientLogger = EssClientLogger;
//# sourceMappingURL=EssClientLogger.js.map